import { Stack } from '@mui/material';
import { UserResponse } from '@/types/user';
import { titleCase } from '@/utils/stringCaser';
import { SVLink, SVSummaryCard } from '@/components/core';
import { SVSummaryCardItem } from '@/types/common';
import { ROUTES } from '@/constants/routes';
import { FORM_FIELDS } from '@/constants/formFields';

type ProfileBasicStaffInfoProps = {
  user: UserResponse;
};

export default function ProfileBasicStaffInfo({
  user,
}: ProfileBasicStaffInfoProps) {
  const items: SVSummaryCardItem[] = [
    {
      label: FORM_FIELDS.FIRST_NAME.label,
      text: user.firstName,
    },
    {
      label: FORM_FIELDS.LAST_NAME.label,
      text: user.lastName,
    },
    {
      label: FORM_FIELDS.EMAIL.label,
      text: user.email,
    },
    {
      label: FORM_FIELDS.PHONE.label,
      text: user.phoneNumber,
    },
    {
      label: FORM_FIELDS.BUSINESS_PHONE.label,
      text: user.businessPhoneNumber,
    },
    {
      label: 'Role',
      text: titleCase(user.role.replace('_', ' ')),
    },
    {
      label: 'Title',
      text: user.title,
    },
    {
      label: 'Companies',
      customContent: user.staffInfo?.companies.length ? (
        <Stack spacing={1}>
          {user.staffInfo.companies.map(company => (
            <SVLink
              key={company.uuid}
              to={`${ROUTES.COMPANIES}/${company.uuid}`}>
              {company.name}
            </SVLink>
          ))}
        </Stack>
      ) : null,
    },
    {
      label: 'Bio',
      text: user.bio,
    },
  ];

  return (
    <SVSummaryCard label="Basic Info" items={items} avatar={user.avatarUrl} />
  );
}
